<div class="agec-result">
    <div class="header">
        <h2>{{ product.title }}</h2>
        <span class="paragraph-small">
            <ng-container class="product-reference" i18n="@@hermes.environment.product-reference"
                >PRODUCT REFERENCE
            </ng-container>
            : {{ product.sku }}
        </span>
    </div>
    <div class="content">
        @if (product.imageUrl) {
        <div class="product-img">
            <picture>
                @for (productImageSrc of productImageSrcSet; track productImageSrc) {
                <source [attr.srcset]="productImageSrc.srcSet" [attr.media]="productImageSrc.mediaQuery" />
                }
                <img [attr.src]="product.imageUrl + '?hei=414&wid=414'" [attr.alt]="product.title" />
            </picture>
        </div>
        }
        <div class="content-text">
            @if (product.compositionAttributes && product.compositionAttributes.length > 0) {
            <h-composition-attribute [compositionAttributes]="product.compositionAttributes"></h-composition-attribute>
            }
            <div class="traceability-recyclability">
                @if (product.traceabilityAttributes && product.traceabilityAttributes.length > 0) {
                <h-traceability-attribute
                    [hasRecyclability]="!!product.recyclabilityAttributes && product.recyclabilityAttributes.length > 0"
                    [traceabilityAttributes]="product.traceabilityAttributes"></h-traceability-attribute>
                } @if (product.recyclabilityAttributes && product.recyclabilityAttributes.length > 0) {
                <h-recyclability-attribute
                    [recyclabilityAttributes]="product.recyclabilityAttributes"></h-recyclability-attribute>
                }
            </div>
            <div class="sustainable-development-link">
                <a
                    (click)="clickOnSustainableDevelopmentLink($event)"
                    href="{{ urlSustainableDevelopment }}"
                    i18n="@@hermes.environment.sustainable_development"
                    >Découvrir les engagements d’Hermès en terme de développement durable
                </a>
            </div></div
        >
    </div>
</div>
